export default __webpack_public_path__ + "static/media/profile-blue.b011ec86.svg";